export const PARTNER_ITEM_NAME_LABELS = ["送り出し機関", "労働局届出済"] as const;

export const PARTNER_CONTACT_METHOD_LABELS = ["メール", "電話", "Facebook", "LINE", "WeChat", "その他"] as const;

export const PARTNER_IMPORT_MAX_ROWS = 200;

export const PARTNER_IMPORT_PARSE_YIELD_INTERVAL = 100;
